import React from "react"

/************************************
 * ACTION TYPE
 ************************************/
const REDUX_SESSION_TIME_OUT = "REDUX_SESSION_TIME_OUT"
const REDUX_SESSION_TIME_OUT_RESET = "REDUX_SESSION_TIME_OUT_RESET"

/************************************
 * TYPES
 ************************************/
type InitialStateType = {
  timeOut: boolean
}

type ActionType = {
  type: "REDUX_SESSION_TIME_OUT" | "REDUX_SESSION_TIME_OUT_RESET"
  timeOut?: boolean
}

type TimeOutType = () => ActionType

/************************************
 * ACTIONS
 ************************************/
export const sessionTimeOut: TimeOutType = () => {
  return {
    type: REDUX_SESSION_TIME_OUT,
  }
}

export const sessionTimeOutReset = () => {
  return {
    type: REDUX_SESSION_TIME_OUT_RESET,
  }
}

/************************************
 * Reducer
 ************************************/
const initialState: InitialStateType = {
  timeOut: false,
}

export default (state = initialState, action: ActionType) => {
  switch (action.type) {
    case REDUX_SESSION_TIME_OUT:
      return {
        timeOut: true,
      }
    case REDUX_SESSION_TIME_OUT_RESET:
      return {
        timeOut: false,
      }
    default:
      return state
  }
}
